import { ToastContainer } from "react-toastify"
import MuiThemeProvider from "theme"

import Routes from "./routes"

import "react-toastify/dist/ReactToastify.css"

const App = () => (
  <MuiThemeProvider>
    <Routes />
    <ToastContainer />
  </MuiThemeProvider>
)

export default App
